import "./path0.6aa9045e.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire383b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire383b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bWJvp", function(module, exports) {

$parcel$export(module.exports, "CircleBuilder", () => (parcelRequire("1e2CL")).default);
$parcel$export(module.exports, "GravityGame", () => (parcelRequire("3cFIV")).default);

var $1urcm = parcelRequire("1urcm");

var $1e2CL = parcelRequire("1e2CL");

var $3cFIV = parcelRequire("3cFIV");

});
parcelRegister("1urcm", function(module, exports) {

$parcel$export(module.exports, "DraggableWrapper", () => $9671467aa63eeaf5$export$c90b8390bef315b4);
$parcel$export(module.exports, "DraggableSvgGroup", () => $9671467aa63eeaf5$export$f1ef387dbbb7dd37);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("l3slk");
var $bmMHa = parcelRequire("bmMHa");
function $9671467aa63eeaf5$export$c90b8390bef315b4({ children: children, initial: initial = {
    x: 0,
    y: 0
} }) {
    const { position: position, handlers: handlers } = (0, $bmMHa.useDraggable)(initial);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ...handlers,
        style: {
            position: 'absolute',
            left: position.x,
            top: position.y,
            cursor: 'move'
        },
        children: children
    });
}
function $9671467aa63eeaf5$export$f1ef387dbbb7dd37({ children: children, initial: initial = {
    x: 0,
    y: 0
} }) {
    const { position: position, handlers: handlers } = (0, $bmMHa.useDraggable)(initial);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        transform: `translate(${position.x},${position.y})`,
        ...handlers,
        style: {
            cursor: 'move'
        },
        children: children
    });
}

});
parcelRegister("l3slk", function(module, exports) {

$parcel$export(module.exports, "useDraggable", () => (parcelRequire("bmMHa")).useDraggable);

var $bmMHa = parcelRequire("bmMHa");

});
parcelRegister("bmMHa", function(module, exports) {

$parcel$export(module.exports, "useDraggable", () => $846785a3f4208a72$export$df30c81f5aa01ff7);

var $acw62 = parcelRequire("acw62");
function $846785a3f4208a72$export$df30c81f5aa01ff7(initial = {
    x: 0,
    y: 0
}) {
    const [position, setPosition] = (0, $acw62.useState)(initial);
    const [dragging, setDragging] = (0, $acw62.useState)(false);
    const [offset, setOffset] = (0, $acw62.useState)({
        x: 0,
        y: 0
    });
    const onMouseDown = (0, $acw62.useCallback)((e)=>{
        setDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
        e.stopPropagation();
    }, [
        position
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dragging) return;
        const onMouseMove = (e)=>{
            setPosition({
                x: e.clientX - offset.x,
                y: e.clientY - offset.y
            });
        };
        const onMouseUp = ()=>setDragging(false);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        return ()=>{
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [
        dragging,
        offset
    ]);
    return {
        position: position,
        isDragging: dragging,
        handlers: {
            onMouseDown: onMouseDown
        }
    };
}

});



parcelRegister("1e2CL", function(module, exports) {

$parcel$export(module.exports, "default", () => $17b590fb30a1ee4c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1urcm = parcelRequire("1urcm");
function $17b590fb30a1ee4c$var$CircleCanvas({ circles: circles }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 1500,
        height: 1000,
        children: circles.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1urcm.DraggableSvgGroup), {
                initial: {
                    x: c.cx,
                    y: c.cy
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: 0,
                    cy: 0,
                    r: c.r,
                    fill: c.fill
                })
            }, c.id))
    });
}
function $17b590fb30a1ee4c$var$StopButton({ onClick: onClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1urcm.DraggableWrapper), {
        initial: {
            x: window.innerWidth / 2 - 100,
            y: window.innerHeight / 2 - 100
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            className: "octagon",
            onClick: onClick,
            children: "STOP"
        })
    });
}
function $17b590fb30a1ee4c$export$2e2bcd8739ae039() {
    const [circles, setCircles] = (0, $acw62.useState)([]);
    const [circleCount, setCircleCount] = (0, $acw62.useState)(0);
    const addCircle = (color = "black")=>{
        setCircles((prev)=>[
                ...prev,
                {
                    id: Date.now(),
                    cx: 100,
                    cy: 100,
                    r: 40,
                    fill: color
                }
            ]);
        setCircleCount((prev)=>prev + 1);
    };
    (0, $acw62.useEffect)(()=>{
        if (circleCount > 5) window.location.assign('/index.html');
    }, [
        circleCount
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($17b590fb30a1ee4c$var$StopButton, {
                onClick: ()=>addCircle()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($17b590fb30a1ee4c$var$CircleCanvas, {
                circles: circles
            })
        ]
    });
}

});

parcelRegister("3cFIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $97985c060656b5d7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $97985c060656b5d7$var$GAME_CONFIG = {
    width: 1000,
    height: 500,
    radius: 20,
    gravity: 0.5,
    jumpStrength: -12,
    moveSpeed: 5,
    bounceFactor: 0.2,
    damageThreshold: 16,
    damageMultiplier: 10 // how much damage per unit of velocity
};
const $97985c060656b5d7$var$PLATFORMS = [
    {
        x: 100,
        y: 300,
        width: 200,
        height: 10
    },
    {
        x: 400,
        y: 200,
        width: 150,
        height: 10
    },
    {
        x: 600,
        y: 330,
        width: 120,
        height: 10
    },
    {
        x: 800,
        y: 400,
        width: 50,
        height: 10
    }
];
const $97985c060656b5d7$var$oofSound = new Audio('https://www.myinstants.com/media/sounds/roblox-death-sound_1.mp3');
$97985c060656b5d7$var$oofSound.volume = 0.5;
function $97985c060656b5d7$export$2e2bcd8739ae039() {
    const { width: width, height: height, radius: radius, gravity: gravity, jumpStrength: jumpStrength, moveSpeed: moveSpeed, bounceFactor: bounceFactor, damageThreshold: damageThreshold, damageMultiplier: damageMultiplier } = $97985c060656b5d7$var$GAME_CONFIG;
    const positionRef = (0, $acw62.useRef)({
        x: 100,
        y: 100
    });
    const velocityRef = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const keysRef = (0, $acw62.useRef)({});
    const inAirRef = (0, $acw62.useRef)(false);
    const animationRef = (0, $acw62.useRef)(null);
    const [displayPosition, setDisplayPosition] = (0, $acw62.useState)({
        x: 100,
        y: 100
    });
    const [damage, setDamage] = (0, $acw62.useState)(0);
    const [flashRed, setFlashRed] = (0, $acw62.useState)(false);
    const sayOof = ()=>{
        const sound = $97985c060656b5d7$var$oofSound.cloneNode();
        sound.volume = 0.5;
        sound.currentTime = 0.5;
        sound.play().catch((err)=>console.log('Audio blocked:', err));
    };
    const takeDamage = (amount)=>{
        sayOof();
        setDamage((prev)=>prev + amount);
        setFlashRed(true);
        setTimeout(()=>setFlashRed(false), 150);
    };
    const checkImpact = (velocityBeforeCollision)=>{
        if (velocityBeforeCollision > damageThreshold) {
            const dmg = Math.floor((velocityBeforeCollision - damageThreshold) * damageMultiplier);
            takeDamage(dmg);
        }
    };
    const checkIfOnPlatform = (x, y)=>{
        return $97985c060656b5d7$var$PLATFORMS.some((plat)=>y + radius >= plat.y - 1 && y + radius <= plat.y + 1 && x + radius > plat.x && x - radius < plat.x + plat.width);
    };
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            keysRef.current[e.key] = true;
        };
        const handleKeyUp = (e)=>{
            keysRef.current[e.key] = false;
        };
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        const update = ()=>{
            let { x: x, y: y } = positionRef.current;
            let vy = velocityRef.current.y;
            // Horizontal movement
            if (keysRef.current['ArrowLeft']) x -= moveSpeed;
            if (keysRef.current['ArrowRight']) x += moveSpeed;
            // Ground/platform check
            const onGround = y >= height - radius || checkIfOnPlatform(x, y);
            if (onGround) inAirRef.current = false;
            // Jump
            if (keysRef.current['ArrowUp'] && onGround && !inAirRef.current) {
                vy = jumpStrength;
                inAirRef.current = true;
            }
            // Apply gravity
            vy += gravity;
            y += vy;
            // Floor collision
            if (y >= height - radius) {
                y = height - radius;
                checkImpact(vy); // Check damage before bounce
                vy = -vy * bounceFactor;
            }
            // Platform collisions
            for (const plat of $97985c060656b5d7$var$PLATFORMS)if (vy > 0 && y + radius >= plat.y && y + radius <= plat.y + vy + 1 && x + radius > plat.x && x - radius < plat.x + plat.width) {
                y = plat.y - radius;
                checkImpact(vy); // Check damage before bounce
                vy = -vy * bounceFactor;
            }
            // Wall boundaries
            if (x < radius) x = radius;
            if (x > width - radius) x = width - radius;
            // Update refs
            positionRef.current = {
                x: x,
                y: y
            };
            velocityRef.current.y = vy;
            // Update display state
            setDisplayPosition({
                x: x,
                y: y
            });
            animationRef.current = requestAnimationFrame(update);
        };
        animationRef.current = requestAnimationFrame(update);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (damage > 99) window.location.assign('/visitors_log.html');
    }, [
        damage
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'relative',
            display: 'inline-block'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    position: 'absolute',
                    top: 10,
                    left: 10,
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#333',
                    zIndex: 10
                },
                children: [
                    "Damage: ",
                    damage
                ]
            }),
            flashRed && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255, 0, 0, 0.3)',
                    pointerEvents: 'none',
                    zIndex: 5
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                style: {
                    background: '#d9f7ff',
                    display: 'block'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: displayPosition.x,
                        cy: displayPosition.y,
                        r: radius,
                        fill: "crimson"
                    }),
                    $97985c060656b5d7$var$PLATFORMS.map((plat, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: plat.x,
                            y: plat.y,
                            width: plat.width,
                            height: plat.height,
                            fill: "#444444ff",
                            rx: "4",
                            ry: "4"
                        }, idx))
                ]
            })
        ]
    });
}

});



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");
parcelRequire("bWJvp");
var $1e2CL = parcelRequire("1e2CL");

function $92f79c02254f5f8c$var$App() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Circles!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Click the STOP button to add circles. Drag them around!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e2CL.default), {})
        ]
    });
}
const $92f79c02254f5f8c$var$root = (0, $aRPiL.createRoot)(document.getElementById('root'));
$92f79c02254f5f8c$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($92f79c02254f5f8c$var$App, {}));


//# sourceMappingURL=circles.e449c58d.js.map
